import { EmailOutlined, Phone as PhoneIcon } from '@mui/icons-material';
import { Avatar, Box, Chip, IconButton, Link, Paper, Typography } from '@mui/material';
import React from 'react';

export interface ContactCardProps {
  name: string;
  title: string;
  phone: string;
  email: string;
  projectType: {
    label: string;
    backgroundColor: string;
  };
  avatarInitials: string;
}

const ContactCard: React.FC<ContactCardProps> = (props) => {
  const { name, title, phone, email, projectType, avatarInitials } = props;

  const formatPhoneForTel = (phoneNumber: string): string => {
    return `tel:+1${phoneNumber.replace(/\D/g, '')}`;
  };

  return (
    <Paper
      style={{
        padding: 16,
        borderRadius: 10,
        backgroundColor: '#ffffff',
        border: '1px solid #EBEBEB',
        height: '100%',
      }}
    >
      <Box
        display="flex"
        alignItems="flex-start"
        justifyContent="space-between"
      >
        <Box
          display="flex"
          alignItems="flex-start"
          style={{ gap: 12, flex: 1 }}
        >
          <Avatar
            alt={name}
            style={{
              width: 60,
              height: 60,
            }}
          >
            {avatarInitials}
          </Avatar>
          <Box>
            <Chip
              label={projectType.label}
              size="small"
              style={{
                backgroundColor: projectType.backgroundColor,
                color: '#080808',
                fontWeight: 600,
                fontSize: 11,
                marginBottom: 8,
                height: 22,
              }}
            />
            <Typography
              variant="h5Alt"
              style={{ marginBottom: 4, fontWeight: 600 }}
            >
              {name}
            </Typography>
            <Typography
              variant="body2"
              style={{ marginBottom: 12, color: '#666666' }}
            >
              {title}
            </Typography>
            <Box
              display="flex"
              flexDirection="column"
              style={{ gap: 8 }}
            >
              <Link
                href={formatPhoneForTel(phone)}
                style={{
                  color: '#080808',
                  textDecoration: 'none',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 8,
                }}
              >
                <PhoneIcon
                  style={{ 
                    fontSize: 16, 
                    color: '#4CAF50' 
                  }}
                />
                <Typography
                  variant="body2"
                  style={{ color: '#080808' }}
                >
                  {phone}
                </Typography>
              </Link>
              <Link
                href={`mailto:${email}`}
                style={{
                  color: '#080808',
                  textDecoration: 'none',
                }}
              >
                <Typography
                  variant="body2"
                  style={{ color: '#080808' }}
                >
                  {email}
                </Typography>
              </Link>
            </Box>
          </Box>
        </Box>
        <Box
          display="flex"
          alignItems="center"
          style={{ gap: 8 }}
        >
          <IconButton
            size="small"
            style={{
              border: '1px solid #EBEBEB',
              padding: 8,
            }}
            onClick={() => window.open(formatPhoneForTel(phone))}
          >
            <PhoneIcon
              style={{ fontSize: 20 }}
            />
          </IconButton>
          <IconButton
            size="small"
            style={{
              border: '1px solid #EBEBEB',
              padding: 8,
            }}
            onClick={() => window.open(`mailto:${email}`)}
          >
            <EmailOutlined
              style={{ fontSize: 20 }}
            />
          </IconButton>
        </Box>
      </Box>
    </Paper>
  );
};

export default ContactCard;
